<template>
    <v-container fluid class="px-0 py-0">
        <v-row align="center" justify="center">
            <v-col cols="12" md="3">
                <v-card class="px-5 d-flex align-center rounded-xl" height="150px" @click="$router.push('/users')">
                    <v-row justify="center" align="center">
                        <v-col cols="4" align="start">
                            <v-icon style="font-size:80px; color:#40c9c6;">mdi-account-multiple</v-icon>
                        </v-col>
                        <v-col cols="8">
                            <v-card-title>
                                {{ $t('home.users') }}
                            </v-card-title>
                            <v-card-subtitle style="font-size:22px;">
                                {{ membershipsMetrics ? membershipsMetrics.userCount : 0 }}
                            </v-card-subtitle>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" md="3">
                <v-card class="px-5 d-flex align-center rounded-xl" height="150px" @click="$router.push('/coaches')">
                    <v-row justify="center" align="center">
                        <v-col cols="4" align="start">
                            <v-icon style="font-size:80px; color:#6499faff;">mdi-whistle</v-icon>
                        </v-col>
                        <v-col cols="8">
                            <v-card-title>
                                {{ $t('home.coaches') }}
                            </v-card-title>
                            <v-card-subtitle style="font-size:22px;">
                                {{ coachesMetrics ? coachesMetrics.coachesCount : 0 }}
                            </v-card-subtitle>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" md="3">
                <v-card class="px-5 d-flex align-center rounded-xl" height="150px">
                    <v-row justify="center" align="center">
                        <v-col cols="4" align="start">
                            <v-icon style="font-size:80px; color: #34bfa3;">mdi-cash-plus</v-icon>
                        </v-col>
                        <v-col cols="8">
                            <v-card-title>
                                {{ $t('home.income') }}
                            </v-card-title>
                            <v-card-subtitle style="font-size:22px;">
                                {{ membershipsMetrics ? membershipsMetrics.totalAmount + membershipsMetrics.pendingAmount : 0 }}
                                <v-icon small>mdi-currency-eur</v-icon>
                            </v-card-subtitle>
                            <v-card-subtitle class="my-0 py-0">
                                <div style="color:#34bfa3">
                                    {{ $t('home.collected') }}: {{ membershipsMetrics ? membershipsMetrics.totalAmount : 0 }}
                                    <v-icon x-small>mdi-currency-eur</v-icon>
                                </div>
                                <div style="color:#f4516c">
                                    {{ $t('home.pending') }}: {{ membershipsMetrics ? membershipsMetrics.pendingAmount : 0 }}
                                    <v-icon x-small>mdi-currency-eur</v-icon>
                                </div>
                            </v-card-subtitle>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" md="3">
                <v-card class="px-5 d-flex align-center rounded-xl" height="150px">
                    <v-row justify="center" align="center">
                        <v-col cols="4" align="start">
                            <v-icon style="font-size:80px; color: #f4516c;">mdi-cash-minus</v-icon>
                        </v-col>
                        <v-col cols="8">
                            <v-card-title>
                                {{ $t('home.expenses') }}
                            </v-card-title>
                            <v-card-subtitle style="font-size:22px;">
                                {{ coachesMetrics ? coachesMetrics.totalAmountPayed + coachesMetrics.pendingAmount : 0 }}
                                <v-icon small>mdi-currency-eur</v-icon>
                            </v-card-subtitle>
                            <v-card-subtitle class="my-0 py-0">
                                <div style="color:#34bfa3">
                                    {{ $t('home.paid') }}: {{ coachesMetrics ? coachesMetrics.totalAmountPayed : 0 }}
                                    <v-icon x-small>mdi-currency-eur</v-icon>
                                </div>
                                <div style="color:#f4516c">
                                    {{ $t('home.pending') }}: {{ coachesMetrics ? coachesMetrics.pendingAmount : 0 }}
                                    <v-icon x-small>mdi-currency-eur</v-icon>
                                </div>
                            </v-card-subtitle>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-chip-group
                    v-model="option"
                    column
                    mandatory
                    style="display: inline-block;"
                >
                    <v-chip
                        v-for="(item, index) in [$t('home.membershipsStatus'), $t('home.coachesStatus')]"
                        :key="index"
                        filter
                        active-class="selected-chip"
                        color="white"
                        large
                        mandatory
                        class="font-weight-bold"
                    >
                        {{ item }}
                    </v-chip>
                </v-chip-group>
            </v-col>
            <!-- Sport and SportClass Filter Section -->
            <v-col v-if="option === 0" cols="12">
                <v-card class="rounded-xl">
                    <v-card-title class="py-2">
                        <v-row class="w-100" align="center">
                            <v-col cols="12" lg="2" class="pb-0 pb-lg-2">
                                <span>{{ $t('home.membershipsStatus') }}</span>
                            </v-col>
                            <v-col cols="12" lg="10">
                                <v-row dense class="pt-5">
                                    <v-col cols="12" sm="6" md="4" lg="3">
                                        <v-autocomplete
                                            v-model="selectedSport"
                                            :items="sportOptions"
                                            :item-text="sport => sport && sport.id ? sport.name : $t('home.allSports')"
                                            :return-object="true"
                                            :label="$t('form.selectSport')"
                                            clearable
                                            dense
                                            @change="onFiltersChange"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4" lg="3">
                                        <v-autocomplete
                                            v-model="selectedSportClass"
                                            :items="sportClassOptions"
                                            :item-text="sc => sc && sc.id ? (sc.sport ? sc.sport.name + ' - ' + sc.name : sc.name) : $t('home.allSportClasses')"
                                            :return-object="true"
                                            :label="$t('form.selectSportClass')"
                                            clearable
                                            dense
                                            :disabled="!sportClassOptions.length"
                                            @change="onFiltersChange"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4" lg="2">
                                        <v-select
                                            v-model="datePreset"
                                            :items="datePresetOptions"
                                            :item-text="item => $t(item.labelKey)"
                                            item-value="value"
                                            dense
                                            :label="$t('home.period')"
                                            @change="applyDatePreset"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" lg="2">
                                        <v-text-field
                                            v-model="startDate"
                                            :label="$t('form.startDate')"
                                            type="date"
                                            dense
                                            required
                                            :rules="mandatoryDateRule"
                                            :disabled="datePreset !== 'custom'"
                                            @change="onCustomDateChange"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" lg="2">
                                        <v-text-field
                                            v-model="endDate"
                                            :label="$t('form.endDate')"
                                            type="date"
                                            dense
                                            required
                                            :rules="mandatoryDateRule"
                                            :disabled="datePreset !== 'custom'"
                                            @change="onCustomDateChange"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-data-table
                        :headers="membershipHeaders"
                        :items="membershipsMetrics ? membershipsMetrics.pendingAmountUserMemberships : []"
                        class="elevation-1"
                        hide-default-footer
                        :search="membershipSearch"
                        style="cursor: pointer;"
                        @click:row="$router.push(`/users/${$event.user.id}/edit`)"
                    >
                        <template v-slot:top>
                            <v-text-field
                                v-model="membershipSearch"
                                append-icon="mdi-magnify"
                                :label="$t('button.search')"
                                single-line
                                hide-details
                                class="px-4"
                            />
                        </template>
                        <template v-slot:item.pendingAmount="{ item }">
                            <v-chip
                                :color="getColor(item.pendingAmount)"
                                dark
                            >
                                {{ item.pendingAmount }}
                                <v-icon x-small>mdi-currency-eur</v-icon>
                            </v-chip>
                        </template>
                        <template v-slot:item.sportClass="{ item }">
                            {{ item.sportClass.sport.name }} - {{ item.sportClass.name }}
                        </template>
                        <template v-slot:item.duration="{ item }">
                            {{ getDate(item.startDate) }} - {{ getDate(item.endDate) }}
                        </template>
                        <template v-slot:item.paidAmount="{ item }">
                            {{ item.membership.price - item.pendingAmount }}
                            <v-icon x-small>mdi-currency-eur</v-icon>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
            <v-col v-else cols="12">
                <v-card class="rounded-xl">
                    <v-card-title class="py-2">
                        <v-row class="w-100" align="center">
                            <v-col cols="12" lg="2" class="pb-0 pb-lg-2">
                                <span>{{ $t('home.coachesStatus') }}</span>
                            </v-col>
                            <v-col cols="12" lg="10">
                                <v-row dense class="pt-5">
                                    <v-col cols="12" sm="6" md="4" lg="3">
                                        <v-autocomplete
                                            v-model="selectedSport"
                                            :items="sportOptions"
                                            :item-text="sport => sport && sport.id ? sport.name : $t('home.allSports')"
                                            :return-object="true"
                                            :label="$t('form.selectSport')"
                                            clearable
                                            dense
                                            @change="onFiltersChange"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4" lg="3">
                                        <v-autocomplete
                                            v-model="selectedSportClass"
                                            :items="sportClassOptions"
                                            :item-text="sc => sc && sc.id ? (sc.sport ? sc.sport.name + ' - ' + sc.name : sc.name) : $t('home.allSportClasses')"
                                            :return-object="true"
                                            :label="$t('form.selectSportClass')"
                                            clearable
                                            dense
                                            :disabled="!sportClassOptions.length"
                                            @change="onFiltersChange"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4" lg="2">
                                        <v-select
                                            v-model="datePreset"
                                            :items="datePresetOptions"
                                            :item-text="item => $t(item.labelKey)"
                                            item-value="value"
                                            dense
                                            :label="$t('home.period')"
                                            @change="applyDatePreset"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" lg="2">
                                        <v-text-field
                                            v-model="startDate"
                                            :label="$t('form.startDate')"
                                            type="date"
                                            dense
                                            required
                                            :rules="mandatoryDateRule"
                                            :disabled="datePreset !== 'custom'"
                                            @change="onCustomDateChange"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" lg="2">
                                        <v-text-field
                                            v-model="endDate"
                                            :label="$t('form.endDate')"
                                            type="date"
                                            dense
                                            required
                                            :rules="mandatoryDateRule"
                                            :disabled="datePreset !== 'custom'"
                                            @change="onCustomDateChange"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-data-table
                        :headers="coachHeaders"
                        :items="coachesMetrics ? coachesMetrics.payments : []"
                        class="elevation-1"
                        hide-default-footer
                        :search="coachSearch"
                        style="cursor: pointer;"
                        @click:row="$router.push(`/coaches/${$event.coach.id}/edit`)"
                    >
                        <template v-slot:top>
                            <v-text-field
                                v-model="coachSearch"
                                append-icon="mdi-magnify"
                                :label="$t('button.search')"
                                single-line
                                hide-details
                                class="px-4"
                            />
                        </template>
                        <template v-slot:item.pendingAmount="{ item }">
                            <v-chip
                                :color="getColor(item.pendingAmount)"
                                dark
                            >
                                {{ item.pendingAmount }}
                                <v-icon x-small>mdi-currency-eur</v-icon>
                            </v-chip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import metricsService from '@/services/metrics'
    import momentTimezone from 'moment-timezone'
    import sportService from '@/services/sport'
    import sportClassService from '@/services/sportClass'

    export default {
        name: 'Home',
        data: () => {
            return {
                option: 0,
                membershipSearch: '',
                coachSearch: '',
                membershipsMetrics: null,
                coachesMetrics: null,
                sports: [],
                sportClasses: [],
                selectedSport: { id: null },
                selectedSportClass: { id: null },
                datePreset: 'month',
                startDate: null,
                endDate: null,
                mandatoryDateRule: [
                    v => !!v || 'Field is required'
                ]
            }
        },
        computed: {
            datePresetOptions() {
                return [
                    { labelKey: 'home.currentMonth', value: 'month' },
                    { labelKey: 'home.currentWeek', value: 'week' },
                    { labelKey: 'home.currentYear', value: 'year' },
                    { labelKey: 'home.selection', value: 'custom' }
                ]
            },
            sportOptions() {
                return [{ id: null, name: this.$t('home.allSports') }, ...this.sports]
            },
            sportClassOptions() {
                if (!this.selectedSport || this.selectedSport.id === null) {
                    return [{ id: null, name: this.$t('home.allSportClasses') }, ...this.sportClasses]
                }
                const filtered = this.sportClasses.filter(sc => sc.sport && sc.sport.id === this.selectedSport.id)
                return [{ id: null, name: this.$t('home.allSportClasses') }, ...filtered]
            },
            membershipHeaders() {
                return [
                    { text: this.$t('home.table.userName'), value: 'user.name' },
                    { text: this.$t('home.table.userSurname'), value: 'user.lastName' },
                    { text: this.$t('home.table.membership'), value: 'membership.name' },
                    { text: this.$t('home.table.sportClass'), value: 'sportClass' },
                    { text: this.$t('home.table.duration'), value: 'duration' },
                    { text: this.$t('home.table.pending'), value: 'pendingAmount' },
                    { text: this.$t('home.table.paid'), value: 'paidAmount' }
                ]
            },
            coachHeaders() {
                return [
                    { text: this.$t('home.table.coachName'), value: 'coach.name' },
                    { text: this.$t('home.table.coachSurname'), value: 'coach.lastName' },
                    { text: this.$t('home.table.paid'), value: 'amount' },
                    { text: this.$t('home.table.pending'), value: 'pendingAmount' }
                ]
            }
        },
        watch: {
            selectedSport() {
                this.selectedSportClass = { id: null }
            }
        },
        created() {
            this.applyDatePreset('month')
            this.fetchAllSports()
            this.fetchAllSportClasses()
            this.refreshAllMetrics()
        },
        methods: {
            applyDatePreset(preset) {
                const currentPreset = preset || this.datePreset
                const today = momentTimezone()
                if (currentPreset === 'month') {
                    this.startDate = today.clone().startOf('month').format('YYYY-MM-DD')
                    this.endDate = today.clone().endOf('month').format('YYYY-MM-DD')
                    this.refreshAllMetrics()
                } else if (currentPreset === 'week') {
                    this.startDate = today.clone().startOf('isoWeek').format('YYYY-MM-DD')
                    this.endDate = today.clone().endOf('isoWeek').format('YYYY-MM-DD')
                    this.refreshAllMetrics()
                } else if (currentPreset === 'year') {
                    this.startDate = today.clone().startOf('year').format('YYYY-MM-DD')
                    this.endDate = today.clone().endOf('year').format('YYYY-MM-DD')
                    this.refreshAllMetrics()
                }
            },
            onCustomDateChange() {
                if (!this.startDate || !this.endDate) {
                    return
                }
                if (momentTimezone(this.startDate).isAfter(momentTimezone(this.endDate))) {
                    this.endDate = this.startDate
                }
                this.refreshAllMetrics()
            },
            onFiltersChange() {
                this.refreshAllMetrics()
            },
            refreshAllMetrics() {
                if (!this.startDate || !this.endDate) {
                    return
                }
                this.getMembershipsMetrics()
                this.getCoachesMetrics()
            },
            fetchAllSports() {
                sportService.getSports().then(resp => {
                    this.sports = resp.data.content
                })
            },
            fetchAllSportClasses() {
                sportClassService.getSportClasses().then(resp => {
                    this.sportClasses = resp.data.content
                })
            },
            getMembershipsMetrics() {
                const params = {}
                if (this.selectedSport && this.selectedSport.id) {
                    params.sportId = this.selectedSport.id
                }
                if (this.selectedSportClass && this.selectedSportClass.id) {
                    params.sportClassId = this.selectedSportClass.id
                }
                params.startDate = this.startDate
                params.endDate = this.endDate
                metricsService.getMemberships(params)
                    .then(response => {
                        this.membershipsMetrics = response.data
                    })
                    .catch(error => {
                        console.error('Error fetching memberships metrics:', error)
                    })
            },
            getCoachesMetrics() {
                const params = {}
                if (this.selectedSport && this.selectedSport.id) {
                    params.sportId = this.selectedSport.id
                }
                if (this.selectedSportClass && this.selectedSportClass.id) {
                    params.sportClassId = this.selectedSportClass.id
                }
                params.startDate = this.startDate
                params.endDate = this.endDate
                metricsService.getCoaches(params)
                    .then(response => {
                        this.coachesMetrics = response.data
                    })
                    .catch(error => {
                        console.error('Error fetching coaches metrics:', error)
                    })
            },
            getColor(item) {
                if (item > 0) {
                    return '#f4516c'
                } else {
                    return '#34bfa3'
                }
            },
            getDate(date) {
                return momentTimezone(date).tz('Europe/Athens').format('YYYY-MM-DD').toString()
            }
        }
    }
</script>

<style>
.selected-chip {
    background-color: white !important;
    color: #40c9c6 !important;
}
</style>
